import { Step } from "react-joyride";
import { ADD_PRODUCT_STEP, SELECT_PRODUCT_STEP } from "./draftTourContent";

const addProductDrawerTourSteps: Step[] = [
  {
    ...SELECT_PRODUCT_STEP,
    placement: "right",
  },
  ADD_PRODUCT_STEP,
];

export default addProductDrawerTourSteps;
